import { memo } from 'react'

/**
 * AnnouncementBulkActions - Bulk action bar for selected announcements
 * 
 * @atomic - Single responsibility: bulk operations UI
 * @idempotent - Same props produce same output
 * 
 * @param {number} selectedCount - Number of selected items
 * @param {Function} onPublish - Bulk publish handler
 * @param {Function} onUnpublish - Bulk unpublish handler
 * @param {Function} onDelete - Bulk delete handler
 * @param {Function} onClear - Clear selection handler
 */
const AnnouncementBulkActions = memo(function AnnouncementBulkActions({
  selectedCount,
  onPublish,
  onUnpublish,
  onDelete,
  onClear
}) {
  if (selectedCount === 0) return null

  return (
    <div className="px-6 py-3 bg-blue-50 border-b border-blue-100 flex items-center justify-between">
      <span className="text-sm font-medium text-blue-900">
        {selectedCount} item(s) selected
      </span>
      <div className="flex gap-2">
        <button
          onClick={onPublish}
          className="px-3 py-1.5 text-sm bg-green-600 text-white rounded hover:bg-green-700"
        >
          Publish Selected
        </button>
        <button
          onClick={onUnpublish}
          className="px-3 py-1.5 text-sm bg-gray-600 text-white rounded hover:bg-gray-700"
        >
          Unpublish Selected
        </button>
        <button
          onClick={onDelete}
          className="px-3 py-1.5 text-sm bg-red-600 text-white rounded hover:bg-red-700"
        >
          Delete Selected
        </button>
        <button
          onClick={onClear}
          className="px-3 py-1.5 text-sm bg-white text-gray-700 border border-gray-300 rounded hover:bg-gray-50"
        >
          Clear Selection
        </button>
      </div>
    </div>
  )
})

export default AnnouncementBulkActions
